export default function LtdLoading({ compact = false }) {
  return (
    <div
      className={`kbv-ltd-loading${compact ? " is-compact" : ""}`}
      role="status"
      aria-live="polite"
    >
      Đang tải...
    </div>
  );
}
